<template>
    <UserWrapper :extraWidth="false" :showTitleContainer="false">
      <template v-if="loading || !accessChecked">
        <Loader />
      </template>
      <div class="job-listing-container" v-else>
        <div class="notice-text p-2 mt-2">
          試験的に導入している機能で、Bloomキャリア登録を導入し<br/>ている大手企業のうち一部の企業の求人閲覧が可能です。
        </div>

        <JobLists
          ref="jobLists"
          :showMatchedJobs="showMatchedJobs"
          :searchKeyword="searchKeyword"
          :companies="companies"
          @search="handleSearch"
          @toggle-change="handleToggleChange"
        />
      </div>
      <template v-slot:footer>
        <Footer/>
      </template>
    </UserWrapper>
</template>

<script>
import UserWrapper from "../UserWrapper.vue";
import JobLists from "./JobLists.vue";
import Loader from "../Loader.vue";
import Footer from "../Footer.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "JobListings",
  components: { UserWrapper, JobLists, Loader, Footer },
  data() {
    return {
      showMatchedJobs: true,
      searchKeyword: "",
      isClientSideSearch: true,
      loading: true,
      accessChecked: false,
    };
  },
  computed: {
    ...mapGetters({
      profile: "getProfile",
      isProfileLoaded: "getIsProfileLoaded",
      companies: "getCompanies",
    }),
  },
  methods: {
    ...mapActions({
      setProfile: "setProfile",
      companiesList: "companiesList",
    }),
    handleToggleChange(newValue) {
      this.showMatchedJobs = newValue;
      this.searchKeyword = "";
    },
    searchJobs() {
      // Implement search functionality
      console.log("Searching for:", this.searchKeyword);
      console.log("Show matched jobs only:", this.showMatchedJobs);
    },
    handleSearch() {
      this.$refs.jobLists.handleSearch();
    },
    async checkAccess() {
      try {
        if (!this.isProfileLoaded) {
          await this.setProfile();
        }

        const profile = this.profile;
        const hasAccess = Object.keys(profile).length > 0 
        
        if (!hasAccess) {
          return this.$router.push('/');
        }
        this.accessChecked = true;
        if (!this.companies || this.companies.length === 0) {
          await this.companiesList();
        }
        // this.loading = false;
      } catch (error) {
        console.error('Failed to check access:', error);
        // this.loading = false;
        this.$router.push('/');  // Redirect on error
      } finally {
        this.loading = false;
      }
    },
  },
  async created() {
    await this.checkAccess();
  }
};
</script>

<style scoped>
>>> .profile-detail-block {
  background-color: #ededed !important;
}
/* Notice text styles */
.notice-text {
  background-color: #ffffff;
  color: #3C3C3C;
  margin-bottom: 20px;
  font-size: 12px;
  line-height: 1.5;
  font-weight: 400;
  padding: 0 px;
}
</style>
